import { type FC, useCallback } from "react";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../../gql-generated/types";
import { getLensSourceTypeLabel } from "../lensSourceTypeLabels";
import { menuItemStyle } from "./AddLensSource.styles";

interface SourceMenuItemProps {
    type: LensSourceType;
    onClick: (type: LensSourceType) => void;
}

export const SourceMenuItem: FC<SourceMenuItemProps> = ({ type, onClick }) => {
    const handleClick = useCallback(() => {
        onClick(type);
    }, [onClick, type]);

    return (
        <div onClick={handleClick} className={menuItemStyle}>
            {getLensSourceTypeLabel(type)}
        </div>
    );
};
